module.exports = __webpack_public_path__ + "static/img/9.7d4ead1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/9.png
// module id = Xq/N
// module chunks = 0